import { useInfiniteQuery } from '@tanstack/react-query'
import { PulsePaginatedFilters } from 'api/pulse'
import { getPayRateByPositionKey } from './keys'
import {
  PayRateByPosition,
  getPayRateByPosition,
} from 'api/pulse/payRateByPosition'
import { PULSE_QUERY_OPTIONS } from './constants'

export function usePayRateByPosition(query: PulsePaginatedFilters) {
  return useInfiniteQuery<PayRateByPosition>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getPayRateByPositionKey(query),
    queryFn: async ({ pageParam = 0, signal }) => {
      const start = (pageParam as number) * query.pageSize
      const fetchedData = await getPayRateByPosition(
        {
          ...query,
          page: start,
        },
        signal
      )
      return fetchedData
    },
    enabled: !!query.companyIds?.length,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      !lastPage.length || lastPage.length < query.pageSize
        ? undefined
        : allPages.length,
  })
}
